import styled from '@emotion/styled';
import { Button as MaterialButton } from '@material-ui/core';
import * as React from 'react';

const StyledButton = styled(MaterialButton)`
  text-transform: none;
`;

type Props = React.ComponentProps<typeof MaterialButton>;
// Generic type that merges Button props with the component's props
type ExtendedProps<C extends React.ElementType> = Props & {
  component?: C;
} & Omit<React.ComponentPropsWithoutRef<C>, keyof Props>;

export const Button = React.forwardRef(
  <C extends React.ElementType>(
    { children, ...rest }: ExtendedProps<C>,
    ref: React.Ref<any>
  ) => (
    <StyledButton ref={ref} {...rest}>
      {children}
    </StyledButton>
  )
);
